import { getMolds } from "../../../helpers/mold.helper";
import OptionFormatter from "../../../components/OptionFormatter";
import AsyncSelect from "react-select/async";
import {
  DebounceContext,
  DebounceContextType,
} from "../../../context/DebounceContext";
import { useContext } from "react";
import { useMoldContext } from "../../../context/MoldContext";
import { fetchMold } from "../../../hooks/useMold";
import useAxios from "../../../utils/useAxios";
import { IMold } from "../../../types/data.interface";
import { Predicates } from "../../../libraries/predicates/predicates";

interface IMoldsAsyncSelectProps {
  onChanged: (...args:any[]) => void,
  value?: IMold[],
  isDisabled?:boolean,
  isMandatory?: boolean,
}
export const MoldsAsyncSelect = ({onChanged, value,isDisabled=false, isMandatory}:IMoldsAsyncSelectProps) => {
  const axios = useAxios();
  const { searchDebounce } = useContext<DebounceContextType>(DebounceContext);
  const { data: moldsFetched, isLoading: isMoldsLoading } = useMoldContext();

  const loadMolds = async (input: string, callback: any) => {
    let options: any = getMolds(moldsFetched);
    if (input.length > 2) {
      const response = await fetchMold({ search: input, axios });
      options = getMolds(response);
    }
    callback(options);
  };

  const handleUpdateMolds = (e:any) => {
    onChanged(e.map((moldOption: any) => moldOption.value))
  }

  return (
    <>
      <label className="form-label">
        Mold(s) {isMandatory && <span className="red-text fw-bold">*</span>}
      </label>
      <AsyncSelect
        cacheOptions
        loadOptions={(input, callback) => {
          searchDebounce(
            loadMolds,
            input,
            getMolds(moldsFetched) ?? [],
            callback,
          );
        }}
        defaultOptions={getMolds(moldsFetched)}
        onChange={handleUpdateMolds}
        value={!!value ? getMolds(value): null}
        formatOptionLabel={OptionFormatter}
        isOptionDisabled={() =>
          Predicates.isNotNullAndNotUndefined(value) &&
          value.length >= 5
        }
        isMulti
        classNamePrefix="react-select"
        placeholder="(min 3 characters, up to 5 molded components)"
        isClearable
        isLoading={isMoldsLoading}
        components={{
          IndicatorSeparator: () => null,
        }}
        isDisabled={isDisabled}
      />
    </>
  )
}